<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Consumption Types &nbsp;
          <add-button
            link="/voyage-monitoring/consumption-types/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Voyage Monitoring</li>
          <li class="breadcrumb-item">Consumption Types</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportconsumption_types.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="consumption_types_excel"
                    :fields="excel_fields"
                    worksheet="Consumption Types"
                    name="Consumption Type.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel</th>
                    <th>Item Name</th>
                    <th>Item Code</th>
                    <th>Measure</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="consumption_types.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(consumption_type, at) in consumption_types"
                    :key="`consumption_type${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ consumption_type.vessel.name }}</td>
                    <td>{{ consumption_type.item_name }}</td>
                    <td>{{ consumption_type.item_code }}</td>
                    <td>{{ consumption_type.measure.name }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/voyage-monitoring/consumption-types/${consumption_type.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(consumption_type.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "consumption_type",
  data() {
    return {
      consumption_types: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      consumption_types_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Vessel: "vessel",
        "Item Name": "item_name",
        "Item Code": "item_code",
        Measure: "measure",
      },
      Exportconsumption_types: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let consumption_types = await axios.get(
        `/consumption_types?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.consumption_types = consumption_types.data.data;
      this.count = consumption_types.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let consumption_types = await axios.get(
        `/consumption_types?search=${this.searchData}`
      );
      this.consumption_types = consumption_types.data.data;
      this.count = consumption_types.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Consumption Type Data";
      this.consumption_types_excel = [];
      let Exportconsumption_types = [];
      Exportconsumption_types = await axios.get(`/consumption_types`);
      this.Exportconsumption_types = Exportconsumption_types.data.data;
      let sr_no = 1;
      this.Exportconsumption_types.forEach((consumption_type) => {
        this.consumption_types_excel.push({
          sr_no: sr_no,
          vessel: consumption_type.vessel.name
            ? consumption_type.vessel.name
            : "",
          item_name: consumption_type.item_name
            ? consumption_type.item_name
            : "",
          item_code: consumption_type.item_code
            ? consumption_type.item_code
            : "",
          measure: consumption_type.measure
            ? consumption_type.measure.name
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=consumption_types`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
